import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai/vanilla";

export const authTokenAtom = atom<string | null>(null);

export const onboardingCompletedAtom = atomWithStorage<boolean>("@arc/main/onboardingCompleted", false, undefined, {
  getOnInit: true,
});

export const referrerAtom = atomWithStorage<string | null>("@arc/main/referrer", null, undefined, {
  getOnInit: true,
});

export const isWalletMigrationFinishedAtom = atomWithStorage<boolean>(
  "@arc/main/isWalletMigrationFinished",
  false,
  undefined,
  {
    getOnInit: true,
  },
);
